/* eslint-disable @typescript-eslint/no-explicit-any */
import { AcaLogLevel, log } from '@aca/core';
import { Subscription } from 'rxjs';
import { SharedServicesModule } from '../shared-services.module';

/**
 * Listen for server events with a provided operation name
 */
export const ServerListen = (operation: string): any => {
  // change name in server-receive.service comment
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalOnInit = target.ngOnInit;
    const originalOnDestroy = target.ngOnDestroy;
    const originalMethod = descriptor.value;

    target.ngOnInit = function (...args: any[]) {
      originalOnInit && originalOnInit.apply(this, args);

      log(AcaLogLevel.Info, {}, ['Subscribing to ' + operation, this.constructor.name])

      const pushService = SharedServicesModule.serverReceiveService;

      this._subscriptions = this._subscriptions || new Map<string, Subscription>();

      const subscription = pushService.subscribe(operation).subscribe((a: any) => {
        log(AcaLogLevel.Info, {}, ['acadv-push', 'Firing ' + operation, this.constructor.name]);
        originalMethod.apply(this, [a]);
      });

      if (this._subscriptions.has(operation)) {
        this._subscriptions.get(operation).unsubscribe();
      }
      this._subscriptions.set(operation, subscription);
    };

    if (!target._subscriptionsOnDestroyRegistered) {
      target.ngOnDestroy = function (...args: any[]) {
        Array.from((this._subscriptions as Map<string, Subscription>).entries()).forEach(([mapKey, sub]) => {
          log(AcaLogLevel.Info, {}, ['acadv-push', 'Unsubscribing ' + mapKey, this.constructor.name]);
          sub.unsubscribe();
          (this._subscriptions as Map<string, Subscription>).delete(mapKey);
        });
        originalOnDestroy && originalOnDestroy.apply(this, args);
      };
      target._subscriptionsOnDestroyRegistered = true;
    }
  };
};
